module.exports = __webpack_public_path__ + "img/outraverse-logo-light.5718e6fe.png";